import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview, GA_TRACKING_ID } from '@/lib/analytics';

export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (GA_TRACKING_ID) {
      const url = location.pathname + location.search;
      pageview(url);
    }
  }, [location]);

  useEffect(() => {
    if (!GA_TRACKING_ID || GA_TRACKING_ID === '') {
      return;
    }

    // Load gtag script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement('script');
    script2.id = 'google-analytics';
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_TRACKING_ID}', {
        page_path: window.location.pathname,
        send_page_view: true
      });
    `;
    document.head.appendChild(script2);

    return () => {
      // Cleanup on unmount
      const existingScript1 = document.querySelector(`script[src*="gtag/js?id=${GA_TRACKING_ID}"]`);
      const existingScript2 = document.getElementById('google-analytics');
      if (existingScript1) existingScript1.remove();
      if (existingScript2) existingScript2.remove();
    };
  }, []);

  return null;
}

